import React, { useState, useEffect } from 'react';
import { Redirect, useParams } from 'react-router-dom';
import SessionService from '../../services/session.service';
import { loginService } from '../../services/login.service';
import { userService } from '../../services/user.service';

const SupportLogin = (props) => {
    const { email } = useParams();
    const [errmsg, setErrmsg] = useState(false);
    const [username, setUsername] = useState(decodeURIComponent(email));
    const [redirect, setRedirect] = useState("/login");
    useEffect(() => {
        localStorage.removeItem('phone');
        localStorage.removeItem('countryCode');
        const data = {
            email: username.trim()
        };

        loginService.authenticateSupport(JSON.stringify(data)).then(authResp => {
            if(!authResp.data?.error) {
                userService.getUser().then((response) => {
                    if(response.data.emailVerify !== 1 && response.data.role.id === 2) {
                        localStorage.setItem("_email_verify", response.data.email);
                    }
                    else {
                        localStorage.removeItem("_email_verify");
                    }
                    setRedirect(authResp.data.redirect);
                }).catch((error) => {
                    setErrmsg("Error while trying to connect");
                });
            }
            else {
                setErrmsg("Invalid Email");
            }
        }).catch(error => {
            let message = error.response.data;
            if(message.status === 500) {
                setErrmsg("Error while connecting, try again");
            }
            else if(message.indexOf("Invalid") !== -1) {
                setErrmsg("Invalid Email");
            }
            else if(message.indexOf("payment") !== -1) {
                setErrmsg(message);
            }
            else {
                setErrmsg(message);
            }
        });
    }, [username]);

    try {
        if(SessionService.getCookie("isLoggedIn")) {
            return <Redirect to={ redirect } replace={ true }></Redirect>;
        }
        else {
            return (
                <div>
                    <p>Support Authentication for user: { username } </p>
                    <p>{ errmsg }</p>
                </div>
            );
        }
    }
    catch(e) {
        return <Redirect to="/login" />;
    }
};

export default SupportLogin;

